export default __webpack_public_path__ + "static/media/expressjs-icon.c4364081.svg";